module.exports = {
    commons: {
        client: {
            singular: 'Cliente',
            plural: 'Clientes',
        },
        specialist: {
            singular: 'Prestador',
            plural: 'Prestadores',
        }
    }
}